import { render, staticRenderFns } from "./TarifasKm.vue?vue&type=template&id=213a3ac6"
import script from "./TarifasKm.vue?vue&type=script&lang=js"
export * from "./TarifasKm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports